"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = exports.Name = exports.PushNotifications = exports.Devel = exports.Suggestions = exports.Info = exports.Success = exports.Warnings = exports.Errors = void 0;
exports.Errors = {
    failedToLoadClaims: "Failed to load user authentication info.",
    failedToLoadFromDB: "Failed to load data from database",
    failedToLoadUserInfo: "Failed to load user info",
    saveFailed: "Save failed",
    deleteFailed: "Delete failed",
    maxUnitsPerOrg: "Reached maximum available groups per organization",
};
exports.Warnings = {};
exports.Success = {};
exports.Info = {
    canceled: "Action canceled",
};
exports.Suggestions = {
    logOutLogIn: "Please try to log out and log in again.",
};
exports.Devel = {
    invalidRequest: "Invalid request",
    dbIncorrectClass: "Passed incorrect object type into db layer",
};
exports.PushNotifications = {
    previewReady: (name) => {
        return { title: "Preview is available", body: `Automatic preview for "${name}" is available. ` };
    },
    previewApproved: (projectName) => {
        return {
            title: "Preview is approved",
            body: `Automatic preview for "${projectName}" is approved. `,
        };
    },
    modelApproved: (projectName) => {
        return {
            title: "Validated model is ready",
            body: `${projectName} has been fully processed and is ready.`,
        };
    },
    modelIssue: (projectName) => {
        return {
            title: "Problematic upload",
            body: `Upload for ${projectName} contains problematic files. Please check your email for more info.`,
        };
    },
};
exports.Name = {
    owners: "Owners",
    allUsers: "All users",
};
exports.Description = {
    owners: "Users with 'Owner' access rights",
    allUsers: "Group which includes all users of this organization",
};
//# sourceMappingURL=messages.js.map